import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { LocalizationPipe } from '../pipes';

@Injectable()
export class PageTitleLocalizationResolver extends TitleStrategy {
  constructor(private readonly title: Title, private readonly localization: LocalizationPipe) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(this.localization.transform(title) ?? title);
    }
  }
}
